export const LOADER = 'APP/LOADER'
export const NAV = 'APP/NAV'
export const USER = 'APP/USER'
export const SERVER = 'APP/SERVER'
export const CHANGE_LANG = 'APP/CHANGE_LANG'
export const ONLINE = 'APP/ONLINE'
export const SHOW_CHAT = 'APP/SHOW_CHAT'
export const DELETE_MESSAGE = 'APP/DELETE_MESSAGE'
export const UPDATE_BALANCE = 'APP/UPDATE_BALANCE'
export const ERROR_SHOW = 'APP/ERROR_SHOW'
export const ERROR_HIDE = 'APP/ERROR_HIDE'
export const BANNER = 'APP/BANNER'
export const STREAMER = 'APP/STREAMER'
export const REFERRAL = 'APP/REFERRAL'
export const UPDATE_REFFERAL = 'APP/UPDATE_REFFERAL'
export const OLD = 'APP/OLD'
export const ONLOAD = 'APP/ONLOAD'
export const LEVEL = 'APP/LEVEL'
export const BONUS = 'APP/BONUS'

export const SEND_MESSAGE = 'CHAT/SEND_MESSAGE'
export const CLEAR_CHAT = 'CHAT/CLEAR_CHAT'

export const HIDE_PAY = 'APP/HIDE_PAY'
export const SHOW_PAY = 'APP/SHOW_PAY'

export const GET_NOTIFICATIONS = 'APP/GET_NOTIFICATIONS'

// tickets

export const GET_TICKETS = 'SUPPORT/GET_TICKETS'
export const GET_TICKET = 'SUPPORT/GET_TICKET'
export const CREATE_TICKET = 'SUPPORT/CREATE_TICKET'
export const CLOSE_TICKET = 'SUPPORT/CLOSE_TICKET'
export const SEND_MESSAGE_TICKET = 'SUPPORT/SEND_MESSAGE_TICKET'
export const CHANGE_MESSAGE_TICKET = 'SUPPORT/CHANGE_MESSAGE_TICKET'

export const CHANGE_CREATE_REASON = 'SUPPORT/CHANGE_CREATE_REASON'
export const CHANGE_CREATE_LANG = 'SUPPORT/CHANGE_CREATE_LANG'
export const CHANGE_CREATE_ISSUE = 'SUPPORT/CHANGE_CREATE_ISSUE'
export const CLEAR_CREATE_POPUP = 'SUPPORT/CLEAR_CREATE_POPUP'


// popups

export const SHOW_TICKET_CREATE = 'POPUPS/SHOW_TICKET_CREATE'
export const HIDE_TICKET_CREATE = 'POPUPS/HIDE_TICKET_CREATE'
export const SHOW_TICKET_CREATED = 'POPUPS/SHOW_TICKET_CREATED'
export const HIDE_TICKET_CREATED = 'POPUPS/HIDE_TICKET_CREATED'
export const SHOW_ROUND_DETAIL = 'POPUPS/SHOW_ROUND_DETAIL'
export const HIDE_ROUND_DETAIL = 'POPUPS/HIDE_ROUND_DETAIL'
export const SHOW_TRADE = 'POPUPS/SHOW_TRADE'
export const HIDE_TRADE = 'POPUPS/HIDE_TRADE'
export const SHOW_CHAT_RULES = 'POPUPS/SHOW_CHAT_RULES'
export const HIDE_CHAT_RULES = 'POPUPS/HIDE_CHAT_RULES'
export const SHOW_STREETRACE_INFO = 'POPUPS/SHOW_STREETRACE_INFO'
export const HIDE_STREETRACE_INFO = 'POPUPS/HIDE_STREETRACE_INFO'
export const SHOW_FREE_INFO = 'POPUPS/SHOW_FREE_INFO'
export const HIDE_FREE_INFO = 'POPUPS/HIDE_FREE_INFO'

export const SHOW_MUTE = 'POPUPS/SHOW_MUTE'
export const HIDE_MUTE = 'POPUPS/HIDE_MUTE'
export const CHANGE_MUTE_HOURS = 'POPUPS/CHANGE_MUTE_HOURS'
export const SHOW_DEPOSIT = 'POPUPS/SHOW_DEPOSIT'
export const HIDE_DEPOSIT = 'POPUPS/HIDE_DEPOSIT'
export const SHOW_DEPOSIT_SUCCESS = 'POPUPS/SHOW_DEPOSIT_SUCCESS'
export const HIDE_DEPOSIT_SUCCESS = 'POPUPS/HIDE_DEPOSIT_SUCCESS'
export const SHOW_DEPOSIT_FAILED = 'POPUPS/SHOW_DEPOSIT_FAILED'
export const HIDE_DEPOSIT_FAILED = 'POPUPS/HIDE_DEPOSIT_FAILED'

export const GET_DEPOSIT = 'POPUPS/GET_DEPOSIT'
export const CHANGE_DEPOSIT_METHOD = 'POPUPS/CHANGE_DEPOSIT_METHOD'
export const CHANGE_DEPOSIT_AMOUNT = 'POPUPS/CHANGE_DEPOSIT_AMOUNT'

export const SHOW_OLD = 'POPUPS/SHOW_OLD'
export const HIDE_OLD = 'POPUPS/HIDE_OLD'

export const SHOW_MOBILE_MENU = 'POPUPS/SHOW_MOBILE_MENU'
export const HIDE_MOBILE_MENU = 'POPUPS/HIDE_MOBILE_MENU'
export const SHOW_MOBILE_CHAT = 'POPUPS/SHOW_MOBILE_CHAT'
export const HIDE_MOBILE_CHAT = 'POPUPS/HIDE_MOBILE_CHAT'
export const SHOW_MOBILE_NOTIFICATION = 'POPUPS/SHOW_MOBILE_NOTIFICATION'
export const HIDE_MOBILE_NOTIFICATION = 'POPUPS/HIDE_MOBILE_NOTIFICATION'

export const SHOW_MOBILE_WITHDRAWS = 'POPUPS/SHOW_MOBILE_WITHDRAWS'
export const HIDE_MOBILE_WITHDRAWS = 'POPUPS/HIDE_MOBILE_WITHDRAWS'

export const SHOW_LEVEL = 'POPUPS/SHOW_LEVEL'
export const HIDE_LEVEL = 'POPUPS/HIDE_LEVEL'


// amount 

export const SET_AMOUNT = 'AMOUNT/SET_AMOUNT'
export const UPDATE_AMOUNT = 'AMOUNT/UPDATE_AMOUNT'
export const SET_MIN_AMOUNT = 'AMOUNT/SET_MIN_AMOUNT'
export const SET_MAX_AMOUNT = 'AMOUNT/SET_MAX_AMOUNT'

export const INPUT_AMOUNT = 'AMOUNT/INPUT_AMOUNT'
export const AMOUNT_PLUS_1 = 'AMOUNT/AMOUNT_PLUS_1'
export const AMOUNT_PLUS_5 = 'AMOUNT/AMOUNT_PLUS_5'
export const AMOUNT_PLUS_10 = 'AMOUNT/AMOUNT_PLUS_10'
export const AMOUNT_PLUS_100 = 'AMOUNT/AMOUNT_PLUS_100'
export const AMOUNT_MYLTIPLY_2 = 'AMOUNT/AMOUNT_MYLTIPLY_2'
export const AMOUNT_SHARE_2 = 'AMOUNT/AMOUNT_SHARE_2'
export const AMOUNT_TO_MAX = 'AMOUNT/AMOUNT_TO_MAX'

// race
export const GET_RACE = 'RACE/GET_RACE'
export const ADD_GAME = 'RACE/ADD_GAME'
export const REMOVE_GAME = 'RACE/REMOVE_GAME'
export const JOIN_GAME = 'RACE/JOIN_GAME'
export const SHOW_TRACK = 'RACE/SHOW_TRACK'


// crash

export const GET_CRASH = 'CRASH/GET_CRASH'
export const GET_CRASH_PREVIOUS = 'CRASH/GET_CRASH_PREVIOUS'

export const CHANGE_AUTOCASH_OUT = 'CRASH/CHANGE_AUTOCASH_OUT'
export const INPUT_AUTOCASH_OUT = 'CRASH/INPUT_AUTOCASH_OUT'

export const ADD_ROUND = 'CRASH/ADD_ROUND'
export const SET_STAGE = 'CRASH/SET_STAGE'

export const CHANGE_BANKROLL = 'CRASH/CHANGE_BANKROLL'

export const ADD_BET = 'CRASH/ADD_BET'
export const NEXT_BET = 'CRASH/NEXT_BET'
export const REMOVE_BET = 'CRASH/REMOVE_BET'
export const CHANGE_BETS_ALL = 'CRASH/ADD_BETS_ALL'
export const ADD_CASHOUT = 'CRASH/ADD_CASHOUT'

export const SET_DELAYS = 'CRASH/SET_DELAYS'
export const DELAY = 'CRASH/DELAY'
export const CURRENT_X = 'CRASH/CURRENT_X'
export const TIMEOUT = 'CRASH/TIMEOUT'
export const INTERVAL = 'CRASH/INTERVAL'
export const CHANGE_TITLE = 'CRASH/CHANGE_TITLE'


// roullete

export const GET_ROULLETE = 'ROULLETE/GET_ROULLETE'
export const GET_ROULLETE_PREVIOUS = 'ROULLETE/GET_ROULLETE_PREVIOUS'
export const ROULLETE_INTERVAL = 'ROULLETE/ROULLETE_INTERVAL'
export const ROULLETE_SECONDS = 'ROULLETE/ROULLETE_SECONDS'
export const SET_ROULLETE_STAGE = 'ROULLETE/SET_ROULLETE_STAGE'
export const ADD_ROULLETE_ROUND = 'ROULLETE/ADD_ROULLETE_ROUND'
export const ADD_ROULLETE_BET = 'ROULLETE/ADD_ROULLETE_BET'
export const CHANGE_ROULLETE_BETS_ALL = 'ROULLETE/CHANGE_ROULLETE_BETS_ALL'
export const WINNER_ROULLET = 'ROULLETE/WINNER_ROULLET'
export const CLEAN_ROLLETE = 'ROULLETE/CLEAN_ROLLETE'
export const MUTE_ROULLETE = 'ROULLETE/MUTE_ROULLETE'


// streetrace

export const GET_STREETRACE = 'STREETRACE/GET_STREETRACE'
export const GET_STREETRACE_PREVIOUS = 'STREETRACE/GET_STREETRACE_PREVIOUS'
export const STREETRACE_INTERVAL = 'STREETRACE/STREETRACE_INTERVAL'
export const STREETRACE_SECONDS = 'STREETRACE/STREETRACE_SECONDS'
export const SET_STREETRACE_STAGE = 'STREETRACE/SET_STREETRACE_STAGE'
export const ADD_STREETRACE_ROUND = 'STREETRACE/ADD_STREETRACE_ROUND'
export const ADD_STREETRACE_BET = 'STREETRACE/ADD_STREETRACE_BET'
export const CHANGE_STREETRACE_BETS_ALL = 'STREETRACE/CHANGE_STREETRACE_BETS_ALL'
export const WINNER_STREETRACE = 'STREETRACE/WINNER_STREETRACE'
export const CLEAN_STREETRACE = 'STREETRACE/CLEAN_STREETRACE'
export const MUTE_STREETRACE = 'STREETRACE/MUTE_STREETRACE'


// profile 

export const GET_PROFILE = 'PROFILE/GET_PROFILE'
export const GET_PROFILE_REWARDS = 'PROFILE/GET_PROFILE_REWARDS'
export const REVERSE_REWARD = 'PROFILE/REVERSE_REWARD'
export const CLAIM_REWARD = 'PROFILE/CLAIM_REWARD'
export const OPEN_REWARD = 'PROFILE/OPEN_REWARD'
export const CHANGE_CODE = 'PROFILE/CHANGE_CODE'
export const GET_PROFILE_RESULTS = 'PROFILE/GET_PROFILE_RESULTS'
export const CHANGE_RESULTS_OFFSET = 'PROFILE/CHANGE_RESULTS_OFFSET'
export const CHANGE_TRADE_URL = 'PROFILE/CHANGE_TRADE_URL'
export const CHANGE_API_KEY = 'PROFILE/CHANGE_API_KEY'
export const CHANGE_RESULTS_LOADING = 'PROFILE/CHANGE_RESULTS_LOADING'
export const LOAD_PROFILE_RESULTS = 'PROFILE/LOAD_PROFILE_RESULTS'

// tot

export const GET_TOT = 'TOT/GET_TOT'
export const GET_TOT_REWARDS = 'TOT/GET_TOT_REWARDS'
export const CHANGE_SELECTED = 'TOT/CHANGE_SELECTED'

// withdraw

export const GET_SKINS = 'WITHDRAW/GET_SKINS'
export const DELETE_SKIN = 'WITHDRAW/DELETE_SKIN'
export const GET_WITHDRAW = 'WITHDRAW/GET_WITHDRAW'
export const ADD_WITHDRAW = 'WITHDRAW/ADD_WITHDRAW'
export const UPDATE_WITHDRAW = 'WITHDRAW/UPDATE_WITHDRAW'
export const DELETE_WITHDRAW = 'WITHDRAW/DELETE_WITHDRAW'
export const LOAD_WITHDRAW = 'WITHDRAW/LOAD_WITHDRAW'
export const CHANGE_LOADING = 'WITHDRAW/CHANGE_LOADING'
export const CHANGE_OFFSET = 'WITHDRAW/CHANGE_OFFSET'
export const CHANGE_ORDER = 'WITHDRAW/CHANGE_ORDER'
export const CHANGE_MIN = 'WITHDRAW/CHANGE_MIN'
export const CHANGE_MAX = 'WITHDRAW/CHANGE_MAX'
export const CHANGE_SEARCH = 'WITHDRAW/CHANGE_SEARCH'
export const SET_SELECTED = 'WITHDRAW/SET_SELECTED'
export const CLEAR_SELECTED = 'WITHDRAW/CLEAR_SELECTED'

// hangars

export const GET_HANGARS = 'HANGARS/GET_HANGARS'
export const OPEN_HANGAR = 'HANGARS/OPEN_HANGAR'
export const CLEAR_OPEN_RESULT = 'HANGARS/CLEAR_OPEN_RESULT'